import React, { FC } from "react";

import { Pill, PillProps } from "../../forms";
import { TagColors, TagDimensions } from "../../forms/elements/tags/types";
import { EventsLabels, EventType } from "../types";

export interface EventTypeTagsProps {
  eventType: EventType;
  labels: EventsLabels;
}

const eventTypeTagProps = {
  color: TagColors.Neutral,
  dimension: TagDimensions.Small,
  className: "w-fit",
} satisfies PillProps;

export const EventTypeTags: FC<EventTypeTagsProps> = ({ eventType, labels }) => {
  return (
    <div className="flex gap-5">
      {(eventType === EventType.IN_PERSON || eventType === EventType.BOTH) && (
        <Pill {...eventTypeTagProps}>{labels["event-type-in-presence"]}</Pill>
      )}
      {(eventType === EventType.DIGITAL || eventType === EventType.BOTH) && (
        <Pill {...eventTypeTagProps}>{labels["event-type-online"]}</Pill>
      )}
    </div>
  );
};
